import type { Video, VideoPreview } from "@brookbush/types";

import Image from "next/image";
import Link from "next/link";

const VideoRelated = ({ video }: { video: Video }) => {
	if (!video.relatedVideos?.length) return null;

	return (
		<section className="flex flex-col phablet:py-2 py-1.5">
			{video.relatedVideos?.map((video: VideoPreview) => (
				<Link href={`/videos/${video.slug}`} key={video._id}>
					<div className="flex cursor-pointer gap-4 phablet:px-4 px-3 phablet:py-2 py-1.5 hover:bg-slate-100 dark:hover:bg-slate-700/50">
						<div className="relative aspect-video h-max w-24 shrink-0 overflow-hidden rounded-lg sm:w-48 xl:w-32">
							<Image
								loading="lazy"
								fetchPriority="low"
								unoptimized
								quality={20}
								src={video.thumbnailUrl!}
								alt={video.title}
								fill
							/>
						</div>
						<div>
							<h3 className="line-clamp-2 font-semibold phablet:text-base text-black text-inherit text-sm">
								{video.title}
							</h3>
						</div>
					</div>
				</Link>
			))}
		</section>
	);
};

export default VideoRelated;
